import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/login': 'Sign In',
  '/pricing': 'Pricing',
  '/resume': 'Resume Analysis',
  '/resume-builder': 'Resume Builder',
  '/settings': 'Settings',
  '/billing': 'Billing',
  '/profile': 'Profile',
  '/analytics': 'Analytics',
  '/quiz': 'Interview Quiz',
  '/interview': 'Mock Interview',
  '/chat': 'AI Assistant',
  '/help': 'Help',
}

/**
 * Hook that tracks page views on route changes
 * - Updates document.title
 * - Sends PageView to Google Analytics
 * - Sends PageView to Meta Pixel
 */
export const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    const path = location.pathname

    // Get page title (handle dynamic routes like /app/:id and /resume/:id)
    let pageTitle = PAGE_TITLES[path]
    if (!pageTitle) {
      if (path.startsWith('/app/')) {
        pageTitle = 'Application Details'
      } else if (path.startsWith('/resume-builder/')) {
        pageTitle = 'Resume Builder Editor'
      } else if (path.startsWith('/resume/')) {
        pageTitle = 'Resume Analysis Results'
      } else if (path.startsWith('/quiz/')) {
        pageTitle = 'Quiz Results'
      } else if (path.startsWith('/interview/')) {
        pageTitle = 'Mock Interview Results'
      } else {
        pageTitle = 'JobTrackr.it'
      }
    }

    // Update document title
    const fullTitle = `${pageTitle} | JobTrackr.it`
    document.title = fullTitle

    // Send to Google Analytics
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_title: pageTitle,
        page_location: window.location.href,
      })
    }

    // Send to Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'PageView', {
        page_path: path,
        page_title: pageTitle,
      })
    }

    // Log in development
    if (import.meta.env.DEV) {
      console.log('[Page Tracking]', { path, pageTitle })
    }
  }, [location.pathname])
}
